<template>
  <div class="error-body">
    <div class="notification is-error content is-love-park-red">
      <h2><i class="fas fa-exclamation-triangle" /> The incarcerated person locator system is currently down.</h2>
    </div>
    <div class="notification content">
      <p> {{ $t('down.text1') }} </p>
      <p>
        <ul id="down">
          <li>Try your search again at a later time.</li>
          <i18n
            path="down.li1.text"
            tag="li"
          >
            <b><a
              place="0"
              :href="'tel:+12156857288'"
              target="'_blank'"
            >{{ $t('down.li1.link1') }}</a></b>
            <b><a
              place="1"
              :href="'tel:+12156857711'"
              target="'_blank'"
            >{{ $t('down.li1.link2') }}</a></b>
            <b><a
              place="2"
              :href="'tel:+12156858909'"
              target="'_blank'"
            >{{ $t('down.li1.link3') }}</a></b>
          </i18n>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
export default {
};
</script>
<style lang="scss">

  @media screen and (max-width: 750px) {
    #down {
    margin-left: 1em;
}
  }

  #down li a {
    color: #0f4d8f;
    text-decoration: none;
  }

  .notification.is-error.content {
    margin-bottom: 0.25rem;
    h2 {
      color: white;
      text-align: -webkit-center;
      margin-bottom: 0;
    }
  }

  .error-body {
    margin: 5rem 0;
    .notification {
      max-width: 750px;
      margin: auto
    }
  }

</style>
